<div class="close-row">
  @if (showCloseButton) {
    <button
      (click)="onClose()"
      [attr.aria-label]="'accessibility.close' | translate"
      class="clear-button"
      style="transform: translateY(0.2rem)">
      <img alt=""
        class="header-img"
        height="25"
        loading="lazy"
        ngSrc="assets/scalableVectorGraphics/close.svg"
        width="25" />
      </button>
    }
  </div>

  @if (title1) {
    <div class="first-row">
      <div class="arrow-back-icon">
        @if (showBackButton) {
          <button
            (click)="onBack()"
            [attr.aria-label]="'accessibility.goBackToDiaryMenu' | translate"
            class="clear-button"
            type="button">
            <img alt="arrow-back"
              class="arrow-back-image"
              loading="lazy"
              src="assets/scalableVectorGraphics/arrow-left-blue.svg">
            </button>
          } @else {
            <div class="dummy-space"></div>
          }
        </div>
        <div class="header-title title-container d-block" [innerHTML]="title1 | translate"></div>
        <div class="info-icon">
          @if (showInfoButton) {
            <app-info-icon
              (click)="onInfo()"
              (toggle)="onInfoButtonToggle()"
              [isInfoNavigation]="isInfoNavigation"
              style="transform: translateY(0.5rem)">
            </app-info-icon>
          }
        </div>
      </div>
    }

    @if (title2) {
      <div class="second-row">
        <div class="header-title">
          {{ title2 | translate }}
        </div>
      </div>
    }

